import React from 'react';
import { MotifIcon, MotifIconButton } from '@ey-xd/motif-react';
import { IconoirPlus, IconoirTrash } from '@ey-xd/motif-icon';

export default (props) => {
  const onAddClick = () => {
    props.handleAddButtonClick(props.data, props.gridRef?.current?.api);
  };
  const onDeleteClick = () => {
    props.handleDeleteButtonClick(props.data, props.gridRef?.current?.api);
  };

  return (
    <div>
      {props.column.colId === 'addactions' && (
        <span className="mt-3">
          <MotifIconButton
            aria-label="Add Tenant Service"
            type="button"
            data-testid="btnNewRow"
            onClick={onAddClick}
          >
            <MotifIcon
              iconFunction={IconoirPlus}
              size="24"
              title="Add Tenant Service"
            />
          </MotifIconButton>
        </span>
      )}

      {props.column.colId === 'deleteactions' && (
        <span className="mt-3">
          <MotifIconButton
            aria-label="Delete Tenant Service"
            type="button"
            data-testid="btnDeleteIcon"
            onClick={onDeleteClick}
          >
            <MotifIcon
              iconFunction={IconoirTrash}
              size="24"
              title="Delete Tenant Service"
            />
          </MotifIconButton>
        </span>
      )}
    </div>
  );
};
